import { Avatar, Flex, Menu } from 'antd';
import { EllipsisOutlined } from '@ant-design/icons';
import { Dropdown } from '@/components/AntdCompatDropdown';
import CustomTitle from '@/components/CustomTitle';
import StatusTag from '@/components/StatusTag.jsx';
import type { ProviderDetailsHeaderProps } from '../types';

const ProviderDetailsHeader = ({
  provider,
  edit,
  handleMenuClick,
  getSensorImagePath,
}: ProviderDetailsHeaderProps) => {
  const menu = (
    <Menu onClick={({ key }) => handleMenuClick(key)}>
      <Menu.Item key='delete' className='sensor-menu-danger'>
        Remove
      </Menu.Item>
    </Menu>
  );

  return (
    <div className='sensor-provider-details-header'>
      <Flex align='center' justify='space-between'>
        <Flex align='center' gap={12}>
          <Avatar
            size={50}
            src={
              <img
                src={getSensorImagePath(
                  provider.name || provider?.sensor_name,
                  'SensorImages'
                )}
                alt='avatar'
                className='sensor-provider-image'
              />
            }
            className='sensor-provider-detail-avatar'
          >
            {provider?.logo ? (
              <img
                src={provider?.logo}
                alt={provider?.sensor_name || provider?.name}
                className='sensor-provider-logo'
              />
            ) : (
              provider?.sensor_name?.charAt(0) || provider?.name?.charAt(0)
            )}
          </Avatar>
          <Flex vertical>
            <CustomTitle
              marginBottom='5px'
              text={provider?.sensor_name || provider?.name}
              fontSize={24}
              fontWeight='700'
              color='var(--text-primary)'
            />
            <StatusTag
              status={
                provider?.status?.toLowerCase() === 'not connected'
                  ? 'Checking Credentials'
                  : provider?.status
              }
            />
          </Flex>
        </Flex>

        {edit && (
          <Dropdown overlay={menu} trigger={['click']}>
            <div className='sensor-details-menu-trigger'>
              <EllipsisOutlined className='sensor-ellipsis-icon' />
            </div>
          </Dropdown>
        )}
      </Flex>
    </div>
  );
};

export default ProviderDetailsHeader;
